import { useCallback, useEffect } from 'react';
import { ArticleDto } from '../../services/dtos/article/article.dto';

type TUpdater = (article: ArticleDto) => void;
interface TReturn {
  send: (article: ArticleDto) => void;
  receive: (updater: TUpdater) => void;
}

const updaters: Record<string, TUpdater> = {};
let handled = false;

const handler = (event: MessageEvent) => {
  try {
    if (event.data.type === 'articleUpdate') {
      Object.values(updaters).forEach((updater) => {
        updater(event.data.article);
      });
    }
  } catch (e) {
    // no handling required
  }
};

export default (key?: string): TReturn => {
  useEffect(() => {
    if (!handled) {
      handled = true;
      window.addEventListener('message', handler);
    }
  }, []);

  return {
    send: useCallback((article) => {
      window.postMessage({ type: 'articleUpdate', article }, '*');

      if (window.opener) {
        window.opener.postMessage({ type: 'articleUpdate', article }, '*');
      }
    }, []),
    receive: useCallback(
      (callback) => {
        if (key) {
          updaters[key] = callback;
        }
      },
      [key]
    ),
  };
};
